import { __assign } from "tslib";
export var IconButtonTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var ownerState = _a.ownerState;
            return (__assign({ borderRadius: theme.borderRadius }, (ownerState.size === 'xsmall' && {
                width: 20,
                height: 20,
            })));
        },
        sizeSmall: {
            width: 24,
            height: 24,
        },
        sizeMedium: {
            width: 32,
            height: 32,
        },
        sizeLarge: {
            width: 40,
            height: 40,
        },
    },
}); };
export default IconButtonTheme;
//# sourceMappingURL=theme.js.map